import "react";
import * as __WEBPACK_EXTERNAL_MODULE__loadable_component__ from "@loadable/component";
const READY_INITIALIZERS = [];
const ALL_INITIALIZERS = [];
const flushInitializers = async (initializers)=>{
    const promises = initializers.map((fn)=>fn());
    // Do not create new array to avoid having old data in any clojure or after async/await
    initializers.length = 0;
    await Promise.all(promises);
    // Loaded chunks can add new initializers, do recursion until everything resolved
    return initializers.length ? flushInitializers(initializers) : void 0;
};
const preloadReady = async ()=>{
    await flushInitializers(READY_INITIALIZERS);
};
const preloadAll = async ()=>{
    await flushInitializers(ALL_INITIALIZERS);
};
const loadable = (loadFn, options)=>{
    const comp = (0, __WEBPACK_EXTERNAL_MODULE__loadable_component__["default"])(loadFn, options);
    ALL_INITIALIZERS.push(async ()=>{
        await comp.load();
    });
    // Babel plugin applied
    if ('object' == typeof loadFn && 'chunkName' in loadFn && 'resolve' in loadFn) {
        const babelOptions = loadFn;
        const moduleId = babelOptions.resolve();
        READY_INITIALIZERS.push(async ()=>{
            // Try to check if this chunk was requested by loadable-components and load
            const modules = __webpack_modules__;
            const isComponentInLoadedChunks = modules?.[moduleId];
            if (isComponentInLoadedChunks) await comp.load();
        });
    }
    // Make interface backward compatible with react-loadable
    const castedComponent = comp;
    castedComponent.preload = (props)=>comp.load(props);
    return castedComponent;
};
/* ESM default export */ const src = loadable;
export { src as default, preloadAll, preloadReady };

//# sourceMappingURL=index.mjs.map